export const projects = [
  {
    title: "funnychat Chat Application",
    subtitle: "React and Firebase",
    description: "I built a secure feature-complete chat app with React and Firebase which also has the authentication process. You can sign in with your google account and join into the chat.",
    image: "./funnychat.gif",
    link: "https://github.com/Sasini2020/funnychat",
  },
  {
    title: "Kanban Board Application",
    subtitle: "Angular and Firebase",
    description: "Has 3 categories of tasks: backlog, in progress, and completed. You can create, delete tasks, and transfer them from one category to another using drag and drop.",
    image: "./kanban-board.gif",
    link: "https://github.com/Sasini2020/kanban-application",
  },
  {
    title: "Conference Management System",
    subtitle: "PHP MySQL HTML CSS",
    description: "This web-based conferenece management system has the main processes in a conference such as event publicizing, research-paper submission, paper review, and reporting.",
    image: "./cms.gif",
    link: "https://github.com/Sasini2020/webcoms-conference-mangement-system",
  },
  {
    title: "Institute Management System",
    subtitle: "Angular NodeJS Bootstrap MySQL",
    description: "A web platform for a private institute to manage its works effectively. It is included modules attendance, class, time-table, registration, request-checking, notification, and payment.",
    image: "./ozone.gif",
    link: "https://github.com/Sasini2020/ozone",
  },
];

export const testimonials = [
  {
    quote:
      "I am a computer science undergraduate in University of Colombo School of Computing. I am still a learner and much prefer to be an expert in this field. ",
    image: "./me.png",
    name: "Sasini",
    uni: "UCSC",
  }
];

export const web = [
  "React",
  "Angular",
  "JavaScript",
  "PHP",
  "JQuery",
  "Sass", "Bootstrap", "Tailwind css"
];

export const programming = [
  "C",
  "C++",
  "Java",
  "Scala"
];

export const db = [
  "MySQL", "Firestore", "MongoDB"
];

export const uix = [
  "Adobe XD",
  "Figma",
];


// WEBPACK FOOTER //
// ./src/data.js